import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./index.css";
import { ThemeProvider } from "./lib/theme";
import { StructuresPage } from "./routes/structures";
import { EditorPage } from "./routes/editor";
import { SharePage } from "./routes/share";
import { DebugGraphPage } from "./routes/debug";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StructuresPage />} />
          <Route path="/s/:id" element={<EditorPage />} />
          <Route path="/share/:token" element={<SharePage />} />
          <Route path="/debug" element={<DebugGraphPage />} />
          <Route path="/debug/graph" element={<DebugGraphPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
